<div class="contacts">

    <h2>
        О нас
    </h2>
    <div class="shop-info" [innerHTML]="textAbout">
    </div>
</div>